import {Component, Input, OnInit} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {DossierInterventionService} from 'app/services/dossier_intervention.service';
import {environment} from 'environments/environment';
import {forEach, map, values} from 'lodash-es';
import {PhotoLieu} from '../../../models/photoLieu.model';
import {Piece} from '../../../models/piece.model';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModalPhotoComponent} from '../fiche-intervention/photo/modal-photo.component';
import {PhotoService} from '../../../services/photo.service';
import {UserService as _UserService} from '../../../core/user/user.service';

@Component({
    selector: 'app-photo-dossier-intervention',
    templateUrl: './photo-dossier-intervention.component.html',
    styleUrls: ['./photo-dossier-intervention.component.scss']
})
export class PhotoDossierInterventionComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention;
    fichesInterventions: any;

    selectedPhotos: number[] = [];
    photos: PhotoLieu[] = [];
    formatedPhotos: {date: string; photos: PhotoLieu[]}[] = [];

    STORAGE_URL = environment.STORAGE_IMAGE;
    downloading: boolean = false;
    pieces: Piece[] = [];

    private isPhotosLoaded: boolean = false;
    private isPiecesLoaded: boolean = false;
    private API_URL= environment.API_URL;

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }
    get isLoaded(): boolean {
        return this.isPiecesLoaded && this.isPhotosLoaded;
    }

    constructor(
        private dossierInterventionService: DossierInterventionService,
        private photoService: PhotoService,
        private http: HttpClient,
        private dialog: MatDialog,
        private _userService: _UserService
    ) {
    }

    ngOnInit(): void {
        this.fetchPieces();
        this.fetchPhotos();
    }

    fetchPhotos(): void {
        this.isPhotosLoaded = false;
        this
            .dossierInterventionService
            .getPhotosParIdDossierIntervention(this.currentDossierIntervention.id)
            .subscribe((result) => {
                this.photos = result;

                const formatedPhotos = {};
                forEach(this.photos, (photo: PhotoLieu) => {
                    const key = new Date(photo.created_at).toISOString().slice(0,10).toString();
                    if (typeof formatedPhotos[key] === 'undefined') {
                        formatedPhotos[key] = [];
                    }
                    formatedPhotos[key].push(photo);
                });

                this.formatedPhotos = map(formatedPhotos, (value: PhotoLieu[], key: string) => ({date: key, photos: value}));
                this.isPhotosLoaded = true;
            });
    }
    fetchPieces(): void {
        this.dossierInterventionService.getPiecesForDossierIntervention(this.currentDossierIntervention.id).subscribe((pieces) => {
            this.pieces = pieces;
            this.isPiecesLoaded = true;
        });
    }

    getNomPiece(piece_id: number): string {
        const piece = this.pieces.find(p => p.id == piece_id);
        return piece ? piece.nom_piece : '';
    }

    toggleAllDate(event, date: string): void {
        this.photos.filter((photo) => {
            const key = new Date(photo.created_at).toISOString().slice(0,10).toString();
            return key === date;
        }).forEach((photo) => {
            if (event.target.checked) {
                if (!this.selectedPhotos.includes(photo.id)) {
                    this.selectedPhotos.push(photo.id);
                }
            } else {
                if (this.selectedPhotos.includes(photo.id)) {
                    this.selectedPhotos.splice(this.selectedPhotos.indexOf(photo.id), 1);
                }
            }
        });
    }

    togglePhoto(event, photo: PhotoLieu): void {
        if (event.target.checked) {
            if (!this.selectedPhotos.includes(photo.id)) {
                this.selectedPhotos.push(photo.id);
            }
        } else {
            if (this.selectedPhotos.includes(photo.id)) {
                this.selectedPhotos.splice(this.selectedPhotos.indexOf(photo.id), 1);
            }
        }
    }
    downloadSelected(): void {
        this.downloading = true;
        this.http.post<any>(this.API_URL + 'photos/download', {photoIds: this.selectedPhotos}, {
            responseType: 'blob' as 'json'
        }).pipe(
            catchError(err => throwError(err))
        ).subscribe((blob)=> {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = (new Date()).toISOString() + '.zip';
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            this.downloading = false;
        });
    }

    openPhotoModal(): MatDialogRef<ModalPhotoComponent> {
        const dialogRef = this.dialog.open(ModalPhotoComponent, {
            width: '75%',
        });

        dialogRef.componentInstance.pieces = this.pieces;
        dialogRef.componentInstance.dossierInterventionId = this.currentDossierIntervention.id;

        dialogRef.afterClosed().subscribe((result) => {
            this.fetchPhotos();
        });

        return dialogRef;
    }

    openSingle(photo: PhotoLieu): void {
        const link = document.createElement('a');
        link.href = this.STORAGE_URL + photo.path;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    delete(photo: PhotoLieu) {
        this.photoService.delete(photo.id).subscribe(()=> {
            this.fetchPhotos();
        });
    }
}
